import React from "react";
import { PageLayout } from "./layout/PageLayout";
import "../styles/App.css";
import Quotes from "./Quotes/Quotes";
import theme from "./layout/theme";
import { ThemeProvider } from "@mui/material";
import {
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import Overview from "./Dashboard/Overview";
import Tst from "../configs/Tst";
import { Route, Routes } from "react-router-dom";
import CreateFromSAP from "./Quotes/CreateFromSAP";

export default function App() {
  console.log(window.location);
  console.log(window.location.pathname);
  console.log(window.location.search);
  console.log(window.location.hash);
  if (window.localStorage.getItem("QUOTEsys") === undefined) {
    window.localStorage.setItem("QUOTEsys", "");
  }
  return (
    <ThemeProvider theme={theme}>
      <PageLayout showlayout>
        <MsalAuthenticationTemplate interactionType="redirect">
          <Routes>
            <Route path="/tst" caseSensitive={false} element={<Tst />} />
            <Route path="/Quote/*" element={<Overview />} />
            <Route path="*" element={<Quotes />} />
            <Route
              path="/QS4"
              caseSensitive={false}
              element={<Quotes sys={"QS4"} />}
            />
            {/* <Route
              path="/DS4"
              caseSensitive={false}
              element={<Quotes sys={"DS4"} />}
            /> */}

            <Route path="/Create">
              <Route path="*" element={"URL is not correct"} />
              <Route
                path=":sys?/:sold/:so/:ship/:qnr/extend"
                element={<CreateFromSAP type="extend" />}
              />
              <Route
                path=":sys?/:sold/:so/:ship/:qnr/replace"
                element={<CreateFromSAP type="replace" />}
              />
              <Route
                path=":sys?/:sold/:so/:ship/:qnr/copy"
                element={<CreateFromSAP type="copy" />}
              />
            </Route>
          </Routes>
        </MsalAuthenticationTemplate>
        <UnauthenticatedTemplate>
          <SignInButton />
        </UnauthenticatedTemplate>
      </PageLayout>
    </ThemeProvider>
  );
}
